module.exports = __webpack_public_path__ + "img/1950.27fd94ad.gif";